import React from 'react';

const StorytellingGameScratch: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p className="mb-4">
        Sebuah game yang sukses dan membekas di ingatan pemain tidak hanya bergantung pada kecanggihan grafis atau kecepatan gameplay, tetapi pada kekuatan narasi dan alur cerita (<i>storytelling</i>) yang disajikan. Di era digital saat ini, penggabungan antara literasi bercerita dan logika komputasi menjadi salah satu sarana edukasi paling efektif untuk merangsang imajinasi anak-anak.
      </p>

      <p className="mb-4">
        Dalam kategori <b>Scratch Coding Game</b> pada ajang <i>Indonesia Innovative Technology (IIT) Challenge</i>, peserta tidak sekadar diminta merancang permainan sederhana, melainkan ditantang untuk membangun dunia interaktif di mana alur cerita, karakterisasi, dan dialog bergerak selaras dengan aksi yang diambil oleh pemain.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Menerapkan Konsep Computational Thinking Lewat Cerita
      </h2>
      <p className="mb-4">
        Ketika seorang anak merancang cerita interaktif di Scratch, mereka secara tidak sadar sedang mempraktikkan pilar-pilar utama <i>Computational Thinking</i>:
      </p>

      <ul className="list-disc pl-6 mb-6 space-y-3">
        <li>
          <strong>Dekomposisi (Decomposition):</strong> Memecah cerita panjang menjadi babak-babak kecil, seperti adegan pembuka (<i>prologue</i>), tantangan utama, hingga adegan penutup (<i>ending</i>).
        </li>
        <li>
          <strong>Pengenalan Pola (Pattern Recognition):</strong> Mengenali kesamaan tingkah laku musuh atau rintangan agar dapat diprogram menggunakan fungsi perulangan (<i>repeat loop</i>).
        </li>
        <li>
          <strong>Abstraksi (Abstraction):</strong> Menentukan informasi mana yang penting ditampilkan di layar dan menyembunyikan detail komputasi internal.
        </li>
        <li>
          <strong>Rancangan Algoritma (Algorithm Design):</strong> Menyusun urutan kejadian logis menggunakan blok penyiaran pesan (<code>broadcast message</code>).
        </li>
      </ul>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Mekanisme Percabangan Cerita (Branching Narrative)
      </h2>
      <p className="mb-4">
        Salah satu daya tarik terbesar dari game berbasis cerita di Scratch adalah kemungkinan terciptanya cerita non-linier. Peserta dapat memprogram pilihan interaktif, di mana setiap keputusan yang dipilih pemain akan membawa karakter ke alur cerita dan akhir kisah (<i>multiple endings</i>) yang berbeda melalui penerapan blok kondisi <code>if-else</code>.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Dampak Positif Jangka Panjang
      </h2>
      <p className="mb-4">
        Integrasi antara seni bercerita, ilustrasi visual, komposisi efek suara, dan pemrograman komputer menjadikan Scratch wadah ideal bagi pendidikan holistik. Anak-anak belajar bahwa teknologi bukan hanya alat teknis yang kaku, melainkan kanvas digital tak terbatas untuk menyampaikan pesan moral dan kepedulian sosial.
      </p>
    </div>
  );
};

export default StorytellingGameScratch;
